import C from '../pages/common/constantes'
import auth from '../services/auth'
import {cents} from '../filters/number'

function recargaValida(val, args){
  
  
  let min = parseInt(args[0]);
  if(!val)
    return false;

  val = parseInt(val.toString().replace(/[^0-9]/g, ''));
  
  if(val > min)
    return true;

  return false;
}


export default {
  messages: {
    en: (field, args) => {
      let min = args[0];
      return `Valor deve ser maior que ${cents(min)}`;
    },
    'pt-BR': (field, args) => {
      let min = args[0];
      return `Valor deve ser maior que ${cents(min)}`;
    }
  },
  validate(value, args) {
    return recargaValida(value, args);
  }
};



// WEBPACK FOOTER //
// ./src/validators/recarga-minima.js